<template>
  <div class="main-slide js-slide">
    <div class="main-slide__content">
      <figure class="main-slide__img js-slide__img">
        <img :src="photos[0].url" alt="Slider vertical photo" />
      </figure>
      <figure class="main-slide__img js-slide__img">
        <img :src="photos[1].url" alt="Slider vertical photo" />
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    photos: []
  }
};
</script>